// extracted by mini-css-extract-plugin
export default {"bottomBackground":"_3Y970tPR2qPs3IxmR8HC38","inner":"_32MMcxQB94Ih-4yVu7pyB7"};